export const getWeeklyHours = (data) => {
  let sum = 0;

  data.dayEntries.forEach((assignmentData) => {
    sum += assignmentData.new_actualhours ?? 0;
  });

  return sum;
};

export const getDayHours = (data) => {
  const daySum = ['DAILY TOTAL'];
  let weekSum = 0;

  for (let index = 0; index <= 6; index++) {
    let dailySum = 0;
    for (let i = 0; i <= data.length; i++) {
      dailySum += data[i]?.dayEntries[index]?.new_actualhours || 0;
    }
    weekSum += dailySum;
    daySum.push(dailySum.toString());
  }
  daySum.push(weekSum.toString());
  return daySum;
};
